import { DirectionMapType, GridProps } from "./Layout.types";
import { getMarginFromProps, getPaddingFromProps } from "../../utils";

import styled from "@emotion/styled";

const directionMap: DirectionMapType = {
  row: "row",
  col: "column",
  "row-r": "row-reverse",
  "col-r": "column-reverse",
};

export const GridWrapper = styled.div<GridProps>`
  display: flex;
  flex-direction: ${(props) =>
    props.direction ? directionMap[props.direction] : "row"};
  gap: ${(props) => props.gap}px;
  justify-content: ${(props) => props.justify || "unset"};
  align-items: ${(props) => props.align || "unset"};
  margin: 0px 20px;
  flex-wrap: warp;
  flex-shrink: 0;
  gap: ${(props) => (props.direction !== "col" ? 10 : 0)}px;
  margin: ${getMarginFromProps};
  padding: ${(props) => getPaddingFromProps(props, "GRID")};
`;

export const GridItemWrapper = styled(GridWrapper)<
  { width: number } & GridProps
>`
  margin: 0px 0px;
  width: ${(props) => props.width}px;
`;
